import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ShareService } from "../shared/service/share.service";
// import { HostListener } from "@angular/core";
import {
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { LoaderService } from "../shared/loader/loader.service";
import { messages } from "../shared/model/Responsemessages";
// import { from } from "rxjs";
import { environment } from "../../environments/environment";
import { RedirectService } from "../Service/redirect.service";
import { TranslateService } from "@ngx-translate/core";
import { TranslationService } from "../common-layout/service/translation.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DeviceDetectorService } from "ngx-device-detector";
import { AuthService } from "../core/auth/auth.service";
import { LocationService } from "../common-layout/layout/header/location/location.service";
import { MenuHorizontalService } from "../common-layout/service/menu-horizontal.service";
import { SettingKey } from "../shared/model/general-settings.model";
// import { ToastrService } from "ngx-toastr";
import { AppointmentToastrService } from "../shared/appointment-toastr/appointment-toastr.service";
import { EncryptionService } from '../utils/encryption.service'
import { FeatureAccessService } from "../shared/service/feature-access.service";
import { StorageService } from "../Service/storage.service";
import { UserRegisterType } from "../login/login.component";

import { Capacitor } from "@capacitor/core";

@Component({
    selector: "kt-patient-selection",
    templateUrl: "./patient-selection.component.html",
    styleUrls: ["./patient-selection.component.scss"],
    standalone: false
})
export class PatientSelectionComponent implements OnInit, OnDestroy {
  currentApplicationVersion = environment.appVersion;
  today: number = Date.now();
  ForgetPasswordEmailForm: FormGroup;
  Domain: string;
  ipAddress: string;
  IsFirst: boolean = false;
  languageChangeSubscription: any;
  loading: boolean = false;
  patientId = new FormControl(null, [Validators.required]);

  displayedColumns: string[] = ['name', 'email'];
  patients: any;
  ipLocation: string;
  deviceType: string;
  selectedOption: any;
  fromLoggedInUser: any = false;
  constructor(
    public shared: ShareService,
    public LoaderService: LoaderService,
    public router: Router,
    private redirect: RedirectService,
    public translate: TranslateService,
    private translationService: TranslationService,
    private cd: ChangeDetectorRef,
    public deviceDetectorService: DeviceDetectorService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    public locationservice: LocationService,
    public menuHorService: MenuHorizontalService,
    public toastrService: AppointmentToastrService,
    private encryptionService: EncryptionService,
    public dialogRef: MatDialogRef<PatientSelectionComponent>,
    public featureAccessService: FeatureAccessService,
    private readonly storageService: StorageService
  ) {

    // this.translate.addLangs(environment?.languages);
    this.translate.use(this.storageService.getItem('language') ? this.storageService.getItem('language') : 'en');
    this.languageChangeSubscription = this.translationService.languageChange.subscribe(
      (newLanguage) => {
        this.translate.use(newLanguage);
        this.cd.detectChanges();
      }
    );

  }

  ngOnInit() {
    this.getData();
    this.patients = this.data?.patientList;
    this.fromLoggedInUser = this.data?.fromLoggedInUser;
    if (!this.fromLoggedInUser) {
      const token = this.storageService.getItem('token');
      const ipAddress = this.storageService.getItem("IA");
      this.storageService.clear();
      if (token) {
        this.storageService.setItem('token', token);
      }
      if (ipAddress) {
        this.storageService.setItem('IA', ipAddress);

      }
      const ipLocation = this.storageService.getItem('ipLocation');
      if (ipLocation) {
        this.storageService.setItem('ipLocation', ipLocation);

      }
    }
    else {
      const foundPatient = this.patients.find(p => p.PatientId == this.storageService.getItem('userId'));
      this.selectedOption = foundPatient ? foundPatient : this.patients[0];
    }

    this.selectedOption = this.patients[0];
    if (this.storageService.getItem('IsFirst') == 'false') {
      this.IsFirst = true;
    }
    this.storageService.removeItem('IsFirst')

  }
  getData() {
    const deviceInfo = this.deviceDetectorService.getDeviceInfo();
    this.deviceType = this.getLoginDeviceType(deviceInfo.deviceType);
  }
  async selectPatient(event: any) {
    this.LoaderService.show();
    if (this.fromLoggedInUser) {
      const token = this.storageService.getItem('token');
      const timeZone = this.storageService.getItem('TimeZone');
      this.storageService.clear();
      if (token) {
        this.storageService.setItem('token', token);
      }
      const ipAddress = this.storageService.getItem("IA");
      if (ipAddress) {
        this.storageService.setItem('IA', ipAddress);

      }
      const ipLocation = this.storageService.getItem('ipLocation');
      if (ipLocation) {
        this.storageService.setItem('ipLocation', ipLocation);
      }
      if (timeZone) {
        this.storageService.setItem("TimeZone", timeZone);
      }
    }
    var patientData = event;
    const userModel: any = {
      Email: patientData.email,
      Domain: window.location.host,
      ipLocation: this.ipLocation ? this.ipLocation : null,
      ipAddress: this.ipAddress ? this.ipAddress : null,
      deviceType: this.deviceType ? this.deviceType : null,
      PatientId: patientData.PatientId,
      Password: patientData.password,
      UserRegisterType: this.data?.UserRegisterType ?? UserRegisterType.Default
    };
    var password = await this.encryptionService.encrypt(userModel.Password)
    userModel.Password = password;
    this.authService.signinUser(userModel).subscribe(
      (response) => {
        if (response["Success"] === true && response["Data"] != null) {
          if (response["Data"]["IsFirst"] == false) {
            this.storageService.setItem("IsFirst", response["Data"]["IsFirst"]);
          }
          this.storageService.setItem("CompanyName", response["Data"].CompanyName);
          this.storageService.setItem("token", response["AccessToken"]);
          this.storageService.setItem("Name", response["Data"].Name);
          this.storageService.setItem("userId", response["Data"].Id);
          this.storageService.setItem("companyId", response["Data"].CompanyId);
          this.storageService.setItem("DoctorTypeId", response["Data"].DoctorTypeId);
          this.storageService.setItem("DoctorTypeName", response["Data"].DoctorTypeObj ? response["Data"].DoctorTypeObj.DoctorTypeName : "");
          this.storageService.setItem("UserName", response["Data"].UserName);


          this.storageService.setItem(
            "selectedPlan",
            response["Data"].selectedPlan ? response["Data"].selectedPlan : "1"
          );
          this.storageService.setItem("AspNetRole", response["Data"].AspNetRoleString);
          this.storageService.setItem("IsTour", response["Data"].IsTour);
          this.storageService.setItem("IsVideoCall", response["Data"].IsVideoCall);
          this.storageService.setItem("IsHomeVisit", response["Data"].IsHomeVisit);
          this.storageService.setItem("IsHospitalVisit", response["Data"].IsHospitalVisit);
          this.storageService.setItem("IsRecoveryVisit", response["Data"].IsRecoveryVisit);

          this.locationservice
            .getDefaultLocation(response["Data"].Id)
            .subscribe((res) => {
              if (res["Data"] != null && res["Success"] === true) {
                this.storageService.setItem(
                  "Location",
                  JSON.stringify({
                    id: res["Data"].LocationId,
                    name: res["Data"].LocationName,
                  })
                );
                this.getFormat(
                  response["Data"].CompanyId
                );
                this.getGeneralSetting();
                this.toastrService.scheduleReminders();
              } else {
                this.getFormat(
                  response["Data"].CompanyId
                );
                this.getGeneralSetting();
              }
            });
          const languageData = response["Data"].LanguageCode || 'en'
          this.storageService.setItem("language", languageData);
          this.featureAccessService.setFeature(response["Data"].SubscriptionAccesses);
        } else if (response["ResponseCode"] == 499 && response["AccessToken"]) {
          // Onboarding user with pending payment — authenticate and go to Dashboard
          this.shared.setOnboardUserStorage(response);
          this.storageService.setItem("IsOnboardingPaymentPending", "true");
          this.LoaderService.hide();
          this.menuHorService.setPath("Dashboard");
          this.router.navigate(["/Dashboard"]).then(() => {
            this.dialogRef.close();
          });
          return;
        } else if (response["ResponseCode"] == 499) {
          this.LoaderService.hide();
          this.shared.showToast(messages[response["ResponseCode"]], "Error");
        } else {
          this.LoaderService.hide();
          this.shared.showToast(messages[response["ResponseCode"]], "Error");
        }
        this.loading = false;
        if (this.fromLoggedInUser) {
          this.router.navigate(["/Dashboard"]).then(() => {
            window.location.reload();
          });
        }
      },
      (error) => {
        this.LoaderService.hide();
        setTimeout(() => {
          if (!this.storageService.getItem("IA")) {
            this.redirect.getIPAddress().subscribe((x: any) => {
              const ipAddress = x.ip;
              this.ipAddress = ipAddress;
              this.storageService.setItem("IA", this.ipAddress);
              if (error.status != 403) {
                this.shared.showToast(error.error.Message, "Error");
              }
            });
          } else {
            if (error.status != 403) {
              this.shared.showToast(error.error.Message, "Error");
            }
          }
        }, 200);
        this.router.navigate([""]);
        this.loading = false;
      }
    );

  }
  ngOnDestroy(): void {
    this.languageChangeSubscription.unsubscribe();
  }


  async getFormat(id: any) {
    await this.shared.getCompanyByIdpromise(id).then((res) => {
      if (res["Success"] === true) {
        if (
          res["Data"]["CurrencyObj"] !== null
            ? res["Data"]["CurrencyObj"].hasOwnProperty("CurrencySymbol")
            : false
        ) {
          this.storageService.setItem(
            "Currency",
            res["Data"]["CurrencyObj"]["CurrencySymbol"]
          );
          this.storageService.setItem(
            "IsWhatsAppDisplay",
            res["Data"]["IsWhatsAppDisplay"]
          );
          this.menuHorService.setPath("Dashboard");
          this.router.navigate(["Dashboard"]).then(() => {
            if (!this.fromLoggedInUser) {
              this.dialogRef.close();
            }
          });
          this.LoaderService.hide();
        }
      } else {
        this.LoaderService.hide();
        this.shared.showToast(this.translate.instant("common.errMsg"), "Error");
      }
    });
  }

  async getGeneralSetting() {
    this.shared.getAllGeneralSetting().subscribe((res) => {
      if (res["Success"] === true) {
        const responce = res["Data"];
        responce.map((item: any) => {
          this.storageService.setItem(item.Key, item.Value);
        });
        let data = res["Data"].find((x) => x.Key == SettingKey.LogoName);
        if (data.LogoData) {
          let str = "data:image/png;base64,";
          this.storageService.setItem("DashboardLogo", `${str}${data.LogoData}`);
        } else {
          this.storageService.setItem("DashboardLogo", null);
        }
      } else {
        this.LoaderService.hide();
        this.shared.showToast(this.translate.instant("common.errMsg"), "Error");
      }
    });
  }
  logoutAndClose() {
    this.authService.logout();
    this.dialogRef.close();
  }
  close() {
    this.dialogRef.close();
  }

  private getLoginDeviceType(_deviceType: string): string {
    const platform = Capacitor.getPlatform();
    if (platform === "android") {
      return "Android";
    }
    if (platform === "ios") {
      return "Ios";
    }
    const isPwa = window.matchMedia?.("(display-mode: standalone)").matches || (window.navigator as any).standalone === true;
    if (isPwa) {
      return "PWA";
    }
    return "Web";
  }
}
